import Vue from 'vue'
import Router from 'vue-router'

import Meta from 'vue-meta'
import routes from './router'
import Store from '@/store'
// 规避重复路由错误
const routerPush = Router.prototype.push
Router.prototype.push = function (location) {
  return routerPush.call(this, location).catch(err => err)
}
const routerReplace = Router.prototype.replace
Router.prototype.replace = function (location) {
  return routerReplace.call(this, location).catch(err => err)
}

Vue.use(Router).use(Meta, {
  refreshOnceOnNavigation: true
})

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({ y: 0 })
        }, 500)
      })
    }
  },
  mode: 'history',
  routes
})

router.beforeEach(async (to, from, next) => {
  // 登录验证
  const allowList = ['login', 'Forget', 'policy', 'error', 'home', 'register']
  if (allowList.includes(to.name) || Store.state.user.userInfo) next()
  else {
    if (from.name === 'login') next(new Error())
    else next(`/login?path=${to.fullPath}`)
  }
})
router.onError(() => {
  document.querySelector('title').innerText = router.currentRoute.meta.title
})

export default router
